import { Modal, ModalFooterProps } from 'react-bootstrap';

export default function CustomModalFooter({
  className,
  ...props
}: ModalFooterProps) {
  return <Modal.Footer className={`border-0 ${className ?? ''}`} {...props} />;
}
